module.exports = __webpack_public_path__ + "assets/images/01_thumb_00f1da720f8bdfb0a9d42cbf9aa25a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/01_thumb.png
// module id = 121
// module chunks = 0